<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content> {{ data.message }}</mat-dialog-content>
<mat-dialog-actions>
  @if(data?.cancel){
  <button mat-button mat-dialog-close>Cancel</button>
  }
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Okay</button>
</mat-dialog-actions>
